import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import {  useNavigate, useParams } from 'react-router-dom'
import { memo, useState } from 'react'
import useAuth from "../../hooks/useAuth"


const TaskBase = ({ taskBase, selected, setSelected }) => {
    const {groupId, type} = useParams()
    const { isTeacher, isAdmin, isStudent } = useAuth()




     const navigate = useNavigate()
     const changeSelected = (checked, taskBaseId) =>{
        if(checked)
            setSelected([...selected, taskBaseId])
        else
        setSelected([...selected.filter(t=> t!= taskBaseId)])
    }

    if (taskBase) {
        //const created = new Date(taskBase.createdAt).toLocaleString('en-US', { day: 'numeric', month: 'long' })
         const handleEdit = () => navigate(`/${type}/${groupId}/task-bases/${taskBase._id}`)
         const cellStatus = taskBase.active ? '' : 'table__cell--inactive'

         let editButton = null
         if(isAdmin|| isTeacher){editButton=(
             <button
             className="icon-button table__button"
             onClick={handleEdit}
         >
             <FontAwesomeIcon icon={faPenToSquare} />
         </button>
         )}
         
   
  
        return (
            <tr className="table__row">

                <td className={`table__cell taskBase__title ${cellStatus}`}>{taskBase.course.name} </td>
                <td className={`table__cell taskBase__title ${cellStatus}`}>{taskBase.title}  </td>
                <td className={`table__cell  ${cellStatus}`} >{taskBase.order}</td>
                <td className={`table__cell  ${cellStatus}`} >{taskBase.ratio? `${taskBase.ratio}%`:'auto' }</td>
                <td className={`table__cell taskBase__actions ${cellStatus}`} >{taskBase.actions?.length}</td>
          

                <td className={`table__cell taskBase__title ${cellStatus}`}>
                    <div style={{display:"flex", alignItems:"center"}}>
                <input checked={selected.includes(taskBase._id)}  className="form__checkbox" id={`cb_${taskBase._id}`} onChange={(e)=>changeSelected(e.target.checked,taskBase._id)} type="checkbox" /><label htmlFor={`cb_${taskBase._id}`} ></label>
                    {editButton}
                    </div>
               
                </td>
            </tr>
        )

    } else return null
}

const memoizedTaskBase = memo(TaskBase)

export default memoizedTaskBase